<template>
  <div>
    <div class="content-header">
      <div class="left">订单应收款</div>
      <div class="right">
        <ButtonGroup>
          <Button :type="mode === 0 ? 'primary' : 'default'" @click="modeChange(0)">按订单</Button>
          <Button :type="mode === 1 ? 'primary' : 'default'" @click="modeChange(1)">按客户</Button>
        </ButtonGroup>
      </div>
      <div class="bottom"></div>
    </div>
    <div>
      <order v-if="mode === 0"/>
      <customer v-if="mode === 1"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import order from "./order";
import customer from "./customer";
export default {
  components: { order, customer },
  data() {
    return {
      mode: 0,
    };
  },
  mounted() {},
  methods: {
    ...mapActions([""]),
    modeChange(e){
      this.mode = e;
    }
  },
  computed: mapGetters({}),
  watch: {},
};
</script>
<style lang='less'>
</style>
